<div class="wrap">
  <h3>{{this.data.camera.name}}</h3>
  <ng-container *ngIf="data.camera.application.ApplicationName === 'SmartParking'">
    <p>Dernière syncronisation:</p>

    <ul>
      <li>Id: <strong>{{this.data.camera.lastSync.id}}</strong></li>
      <li>Status: <strong>{{this.data.camera.lastSync.status}}</strong></li>
      <li>StartedOn: <strong>{{this.data.camera.lastSync.startedOn | date : "medium"}}</strong></li>
      <li>CompletedOn: <strong>{{this.data.camera.lastSync.completedOn | date : "medium"}}</strong></li>
    </ul>
  </ng-container>

  <ng-container *ngIf="data.camera.application.ApplicationName === 'SmartWaste'">
    <p>Dernier appel:</p>

    <strong>{{today | date: 'short'}}</strong>
  </ng-container>
  <br><br>

  <button type="button" (click)="dialogRef.close()">Fermer</button>

</div>